export default {
    'package_version': '1.2.1'
  };
